import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (teamId, team) =>
  f3tch(`/crm/teams/${teamId}/`).profile(profile()).body(team).patch();
